import { defineStore } from "pinia";

import API from "../api/index.js";


export const useArmsStore = defineStore("arms", {

    state: () => ({

       arms: []

    }),
    

    actions: {

      async fetch_arms() {

        const response = await API.fetch_arms(); // Axios interceptor handles errors

        this.arms = response.all_arms || []

      }
   }
})